import { useState } from 'react';
import { Box, Chip, Collapse, IconButton, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { observer } from 'mobx-react-lite';
import { vacancyStore } from 'stores/vacancyStore';
import { WidgetCard } from './shared';

/**
 * Сворачиваемый список навыков вакансии с их порогами оценки.
 * Данные берём из vacancyStore.vacancy.skills — объект { "<навык>": число|null }.
 * Если навыков нет, виджет не рендерится.
 */
const VacancySkillsWidget = () => {
  const { vacancy } = vacancyStore;
  const [open, setOpen] = useState(false);

  const entries = Object.entries(vacancy?.skills ?? {});
  if (entries.length === 0) return null;

  return (
    <WidgetCard
      overline=""
      title="Навыки"
      sx={{ml: '0px !important', height: open ? '100%' : 'auto'}}
      action={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Chip size="small" label={`${entries.length} навыков`} />
          <IconButton
            size="small"
            onClick={() => setOpen((prev) => !prev)}
            aria-label={open ? 'Свернуть список навыков' : 'Развернуть список навыков'}
          >
            <Icon icon={open ? 'mdi:chevron-up' : 'mdi:chevron-down'} width={22} height={22} />
          </IconButton>
        </Stack>
      }
    >
      <Collapse in={open} unmountOnExit>
        <Stack spacing={1}>
          {entries.map(([name, threshold]) => (
            <Stack
              key={name}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
              sx={{
                py: 0.75,
                px: 1.5,
                borderRadius: 1.5,
                bgcolor: 'grey.100',
                border: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: 'grey.900', minWidth: 0, wordBreak: 'break-word' }}
              >
                {name}
              </Typography>
              <Box sx={{ flexShrink: 0 }}>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                    color: threshold == null ? 'text.disabled' : 'primary.main'
                  }}
                >
                  {threshold == null ? 'Порог не задан' : `Порог: ${threshold}`}
                </Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Collapse>
    </WidgetCard>
  );
};

export default observer(VacancySkillsWidget);
